module.exports = __webpack_public_path__ + "assets/83eadff84724e7b5ac38a69707256723.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/anticipate/L585MLA_SpinMelodyR2.mp3
 ** module id = 238
 ** module chunks = 0
 **/